import { Consumer } from 'types/common';

export enum TransactionTypes {
    DEBIT_CNP_CARD = 'CORPORATE',
    SEND_MONEY_TO_MT_CODE = 'SEND_MONEY_TO_MT_CODE',
    LOAD_SVA_FROM_MT_CODE = 'LOAD_SVA_FROM_MT_CODE',
    CVT = 'CVT',
    PERSON_TO_PERSON_TRANSFER = 'PERSON_TO_PERSON_TRANSFER',
    CREATE_ACCOUNT = 'CREATE_ACCOUNT',
    DEBIT = 'DEBIT',
    CREDIT = 'CREDIT',
    CASHIN_BANK_TO_SVA = 'CASHIN_BANK_TO_SVA',
    M2M_PURCHASE = 'M2M_PURCHASE',
    PURCHASE = 'PURCHASE',
    PURCHASE_REFUND = 'PURCHASE_REFUND',
    PURCHASE_CANCEL = 'PURCHASE_CANCEL',
    DEPOSIT_TO_SVA = 'DEPOSIT_TO_SVA',
    CASHOUT_SVA_TO_BANK = 'CASHOUT_SVA_TO_BANK',
    LOAD_SVA_FROM_CREDIT_CARD = 'LOAD_SVA_FROM_CREDIT_CARD',
    SENDMONEY2MTCODE = 'SENDMONEY2MTCODE',
    TRANSFER = 'TRANSFER',
    ADD_LOYALTY_BALANCE = 'ADD_LOYALTY_BALANCE',
    CAPTURE_TRANSACTION = 'CAPTURE_TRANSACTION',
    LOAD_SVA_FROM_POINTS = 'LOAD_SVA_FROM_POINTS',
    GET_BALANCE = 'GET_BALANCE',
    CASHIN_BANK_TO_SVA_CANCEL = 'CASHIN_BANK_TO_SVA_CANCEL',
    LOAD_SVA_FROM_CREDIT_CARD_CANCEL = 'LOAD_SVA_FROM_CREDIT_CARD_CANCEL',
    PERSON_TO_PERSON_TRANSFER_CANCEL = 'PERSON_TO_PERSON_TRANSFER_CANCEL',
    LOAD_SVA_FROM_CREDIT_CARD_REFUND = 'LOAD_SVA_FROM_CREDIT_CARD_REFUND',
    DEBIT_CNP_CARD_REFUND = 'DEBIT_CNP_CARD_REFUND',
    DEFAULT = 'DEFAULT',
    LOADBALANCE = 'LOADBALANCE',
    ERROR_COMMIT_CREDIT_HOLD = 'ERROR_COMMIT_CREDIT_HOLD',
    ERROR_CREDIT_HOLD = 'ERROR_CREDIT_HOLD',
    ROLLBACK_COMMIT_CREDIT_HOLD = 'ROLLBACK_COMMIT_CREDIT_HOLD',
    ROLLBACK_COMMIT_HOLD = 'ROLLBACK_COMMIT_HOLD',
    COMMIT_HOLD = 'COMMIT_HOLD',
    COMMIT_CREDIT_HOLD = 'COMMIT_CREDIT_HOLD',
    CARD_VALIDATION = 'CARD_VALIDATION',
    CONFIRM_CARD = 'CONFIRM_CARD',
    BANK_VALIDATION = 'BANK_VALIDATION',
    CONFIRM_BANK = 'CONFIRM_BANK',
    CANCEL = 'CANCEL',
}
export interface Transaction {
    confirmationCode: string;
    type: string;
    amount: number;
    transactionStatus: string;
    sourceMoneyContainerSubtype: string | null;
    transactionDateTime: string;
    consumer: Consumer;
    maxRefundAmount: number;
    canBeCancelled: boolean;
    canBeRefunded: boolean;
    canRequestRefund: boolean;
}

export interface TransactionDetailsState {
    details: Transaction;
    loading: boolean;
    error: boolean;
}

export interface ExecuteTransactionResponse {
    contextResponse: {
        tenantName: string;
        statusCode: string;
        statusMessage: string;
        additionalStatusMessage?: string;
    };
    confirmationInfo: {
        confirmationDate: string;
        confirmationId: string;
    };
    transactionInfo: {
        timeStamp: string;
        transactionId: string;
    };
}
